module.exports = new __parcel__URL__("cornershop-new-web.a201bd93.webp").toString();